import ActionTypes from '../types.js'

export function changeCommentSelection(id, selected) {
  return {
    type: ActionTypes.COMMENT_SELECTION_CHANGE,
    payload: { id, selected },
  }
}

export function selectAllComments(comments) {
  return {
    type: ActionTypes.COMMENTS_SELECT_ALL,
    payload: comments,
  }
}

export function deselectAllComments(comments) {
  return {
    type: ActionTypes.COMMENTS_DESELECT_ALL,
    payload: comments,
  }
}

export function selectVisible(comments) {
  return {
    type: ActionTypes.COMMENTS_SELECT_VISIBLE,
    payload: comments,
  }
}

export function selectHidden(comments) {
  return {
    type: ActionTypes.COMMENTS_SELECT_HIDDEN,
    payload: comments,
  }
}
